import { UseQueryResult } from "@tanstack/react-query";
//@ts-ignore
import AgroyaarLoading from "../../../gif/Ripple-1s-200px.gif";

interface ReactQueryAsyncValueWrapperProps<T> {
  state: UseQueryResult<T>;
  enabled?: boolean;
  children: (data: T) => React.ReactElement;
}

const ReactQueryAsyncValueWrapper = <T,>({
  state,
  enabled = true,
  children,
}: ReactQueryAsyncValueWrapperProps<T>) => {
  return (state.isLoading || state.isFetching || state.isRefetching) ? (
    <div className="flex items-center justify-center h-full w-full text-8xl ">
      <img src={AgroyaarLoading} alt="fallback" />
    </div>
  ) : state.isError ? (
    <div>{state.error as string}</div>
  ) : typeof state === "undefined" ||
    state.data === null ||
    state.data === undefined ? (
    <div>خطا در اطلاعات دریافتی</div>
  ) : (
    children(state.data as T)
  );
};

export default ReactQueryAsyncValueWrapper;
